import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const ProfessionalTax = () => {
  return (
    <>
      <TopBanner content={"Professional Tax"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>A Small Deduction for State Revenue</h2>
          <p>
            Professional Tax is a tax charged by state governments on
            individuals earning income through employment, freelancing, or
            running a business.
          </p>
          <p>
            It’s usually deducted directly by your employer from your salary
            each month and varies slightly from state to state.
          </p>
          <h3>Key Points:</h3>
          <ul>
            <li>
              Applicable to salaried employees, self-employed professionals, and
              businesses
            </li>
            <li>The maximum amount is ₹2,500 per year (as per state rules)</li>
            <li>
              Paid monthly, quarterly, or annually depending on the profession
              and income
            </li>
            <li>Some states don’t charge professional tax at all</li>
          </ul>

          <p>
            Even though it’s a small amount, paying it keeps you legally
            compliant and penalty-free.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default ProfessionalTax;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
